export const API_BASE = process.env.REACT_APP_API_BASE || "https://buzzinguniverse.com/backend";
export const MEDIA_BASE = process.env.REACT_APP_API_BASE || "https://buzzinguniverse.com/backend";
